<div class="modal-body" [ngSwitch]="step.status_id" [ngClass]="{ hasFeeForm: hasFeeForm }">
    <div *ngSwitchCase="STEP_STATUSES.INCOMPLETE">
        <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
        <cm-step-on-behalf-list *ngIf="step.on_behalf_indicator" [onBehalfIndicator]="step.on_behalf_indicator">
        </cm-step-on-behalf-list>
        <ng-container *ngIf="hasFeeForm && !feeFormWithVoucher" [ngTemplateOutlet]="feeForm"> </ng-container>
        <ng-container *ngIf="!hasFeeForm || feeFormWithVoucher" [ngTemplateOutlet]="feeInfo"> </ng-container>
    </div>
    <div *ngSwitchCase="STEP_STATUSES.PASSED_DUE_DATE">
        <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
        <cm-step-on-behalf-list *ngIf="step.on_behalf_indicator" [onBehalfIndicator]="step.on_behalf_indicator">
        </cm-step-on-behalf-list>
        <cm-message-block
            type="error"
            class="message-block"
            *ngIf="step.content.isLateFeeEnabled && !hasGracePeriodCome"
        >
            Fee amount will increase to {{ currencyIcon$ | async
            }}{{ step.content.lateFee + step.content.fee | cmCurrency }} in {{ daysRemainingToGracePeriod }} day(s)
        </cm-message-block>
        <ng-container *ngIf="hasFeeForm && !feeFormWithVoucher" [ngTemplateOutlet]="feeForm"> </ng-container>
        <ng-container *ngIf="!hasFeeForm || feeFormWithVoucher" [ngTemplateOutlet]="feeInfo"> </ng-container>
    </div>
    <div *ngSwitchCase="STEP_STATUSES.PENDING_VERIFICATION">
        <ng-container *ngIf="paidByThirdParty">
            <p class="third-party-description">3rd party payment option selected</p>
            <p class="third-party-description">{{ step.content.paid_by_third_party_comment }}</p>
        </ng-container>
        <ng-container *ngIf="step.content.documents.length">
            <div class="document-block-header">
                <span class="small-description grey-text">Document(s) pending verification</span>
            </div>
            <cm-files-list [files]="documents"></cm-files-list>
        </ng-container>
        <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
        <ng-container *ngIf="hasFeeForm; else feeInfo" [ngTemplateOutlet]="feeFormPreview"> </ng-container>
    </div>
    <div *ngSwitchCase="STEP_STATUSES.COMPLETED">
        <ng-container *ngIf="paidByThirdParty">
            <p class="third-party-description">3rd party payment option selected</p>
            <p class="third-party-description">{{ step.content.paid_by_third_party_comment }}</p>
        </ng-container>
        <div class="document-block-header" *ngIf="!paidByThirdParty && step.content.documents?.length">
            <span class="small-description grey-text">Payment confirmation</span>
        </div>
        <div *ngFor="let doc of step.content.documents">
            <p>
                <a href="{{ doc.link }}" target="_blank" class="cm-link font-weight-bold document-link">{{
                    doc.name
                }}</a>
                <span class="grey-text small-description">{{ doc.size | fileSize }}</span>
            </p>
        </div>
        <cm-display-html class="details-description" [content]="step.description"></cm-display-html>
        <cm-step-on-behalf-list *ngIf="step.on_behalf_indicator" [onBehalfIndicator]="step.on_behalf_indicator">
        </cm-step-on-behalf-list>
        <ng-container *ngIf="hasFeeForm; else feeInfo" [ngTemplateOutlet]="feeFormPreview"> </ng-container>
    </div>
</div>
<div class="modal-footer footer-container" [ngSwitch]="step.status_id">
    <ng-container *ngIf="isCompletionAvailable">
        <button type="button" class="btn btn-default" *ngIf="feeFormWithVoucher" (click)="backToForm()">BACK</button>
        <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
        <button
            type="button"
            class="btn btn-default"
            *ngIf="!feeFormWithVoucher && step.step_type_id !== STEP_TYPES.TEST_FEE"
            [disabled]="step?._userActionsDisabled || formShouldButNotFilled"
            (click)="goToPage(FeesScreens.ThirdParty)"
        >
            3RD PARTY PAYMENT
        </button>
        <button
            type="button"
            class="btn btn-default"
            [disabled]="step?._userActionsDisabled || formShouldButNotFilled"
            (click)="goToPage(FeesScreens.FileUpload)"
            *ngIf="!feeFormWithVoucher && step.content.upload_enabled"
        >
            UPLOAD EVIDENCE OF PAYMENT
        </button>
        <button
            type="button"
            class="btn btn-primary"
            [disabled]="step._userActionsDisabled || formShouldButNotFilled"
            (click)="goToPage(FeesScreens.Payment)"
        >
            {{ selectedPayment === PAYMENT_TYPES.VOUCHER ? 'SUBMIT' : 'PAY FEE' }}
        </button>
    </ng-container>

    <ng-container *ngIf="!isCompletionAvailable">
        <button
            *ngIf="isPendingVerificationStatus && workflowTypeId === WORKFLOW_MODULE_ID.CREDENTIAL"
            type="button"
            class="btn btn-default"
            (click)="goToPage(FeesScreens.ResetConfirm)"
        >
            RESET
        </button>
        <button type="button" class="btn btn-default" (click)="dismissModal.emit()">CLOSE</button>
    </ng-container>
</div>

<ng-template #feeForm>
    <ng-container *cmLet="(currencyIcon$ | async) as currencyIcon">
        <cm-message-block type="info" class="message-block" *ngIf="!step.content.fee && hasFeeForm"
            >Please choose at least one option
        </cm-message-block>
        <cm-message-block
            type="error"
            class="message-block"
            *ngIf="step.content.isLateFeeEnabled && hasGracePeriodCome"
        >
            Late fee {{ currencyIcon }}{{ step.content.lateFee | cmCurrency }} is applied to your Grand
            Total</cm-message-block
        >
        <div class="fee-row bold" *ngIf="step.content.fee">
            <span>Fees</span><span>{{ currencyIcon }}{{ stepFee | cmCurrency }}</span>
        </div>
        <cm-fee-form-professional
            [previewMode]="preview"
            [feesFormFields]="step.content.feesFormFields"
            [feeAmount]="stepFee"
            (fieldsChange)="feeFormFieldsChange($event)"
        ></cm-fee-form-professional>
    </ng-container>
</ng-template>

<ng-template #feeFormPreview>
    <div class="fee-row bold" *ngIf="step.content.fee">
        <span>Fees</span><span>{{ currencyIcon$ | async }}{{ stepFee | cmCurrency }}</span>
    </div>
    <cm-fee-form-professional
        [previewMode]="true"
        [feesFormFields]="step.content.feesFormFields"
        [feeAmount]="stepFee"
        (fieldsChange)="feeFormFieldsChange($event)"
    >
    </cm-fee-form-professional>
</ng-template>

<ng-template #feeInfo>
    <div class="fee-payment-selector-content">
        <div class="fee-payment-selector-radio" *ngIf="isPaymentTypeVisible">
            <p class="fee-payment-selector-text">How would you like to pay for your examination?</p>
            <cm-radio-group
                [options]="payments"
                [disabled]="step.status_id === STEP_STATUSES.COMPLETED"
                [ngModel]="selectedPayment"
                (ngModelChange)="changePaymentType($event)"
            >
            </cm-radio-group>
        </div>
        <div
            class="fee-payment-selector-voucher"
            *ngIf="selectedPayment === PAYMENT_TYPES.VOUCHER && step.status_id !== STEP_STATUSES.COMPLETED"
        >
            <p class="fee-payment-selector-text required">Your assigned voucher number</p>
            <cm-text-input
                [(ngModel)]="voucherValue"
                class="fee-payment-selector-input"
                [ngClass]="{ 'is-invalid': showVoucherFormatError }"
            >
            </cm-text-input>
        </div>
        <div class="fee-row bold">
            <span>Fees</span><span>{{ currencyIcon$ | async }}{{ paymentAmount | cmCurrency }}</span>
        </div>
    </div>
</ng-template>
